export default __webpack_public_path__ + "static/media/vip-banner-m.d98f1d54.webp";